interface RecostLogoProps {
  size?: number
  showWordmark?: boolean
  wordmarkColor?: string
  className?: string
}

/**
 * Recost brand mark — the orange arrow/chevron icon from the favicon,
 * optionally paired with the "recost" wordmark.
 */
export function RecostLogo({
  size = 24,
  showWordmark = true,
  wordmarkColor = '#0a0a0a',
  className,
}: RecostLogoProps) {
  return (
    <span
      className={className}
      style={{ display: 'inline-flex', alignItems: 'center', gap: size * 0.35 }}
    >
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="25 45 130 90"
        width={size}
        height={size}
        aria-hidden="true"
        style={{ flexShrink: 0, display: 'block' }}
      >
        <path
          fill="#F26B1D"
          d="M 30 50 L 150 50 Q 145 75 80 90 Q 145 105 150 130 L 30 130 Q 100 90 30 50 Z"
        />
      </svg>
      {showWordmark && (
        <span
          style={{
            fontFamily: 'var(--font-display)',
            fontSize: size * 0.85,
            fontWeight: 700,
            letterSpacing: '-0.02em',
            color: wordmarkColor,
            lineHeight: 1,
          }}
        >
          recost
        </span>
      )}
    </span>
  )
}
